import {
    PRINT_DRIVER_PACKAGE_SUMMARY,
    PRINT_DRIVER_PACKAGE_SUMMARY_ERROR, PRINT_DRIVER_PACKAGE_SUMMARY_ERROR_MESSAGE,
    PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS, PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS_MESSAGE,
    RESPONSE_TYPE, TOGGLE_PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON,
} from "../constants/DriverPackageSummaryConstants";
import {printDriverPackageSummary} from "../network/PrintDriverPackageSummaryNetwork";

export const PrintDriverPackageSummaryReducer = (state, action) => {
    switch (action.type) {
        case PRINT_DRIVER_PACKAGE_SUMMARY:
            const  {dispatcher} = action.data;
            printDriverPackageSummary(dispatcher);
            return {...state, printDriverPackageLoading: true, printDriverPackageSuccess: false};
        case PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS:
            return {...state,
                printDriverPackageSummaryData: action.data,
                printDriverPackageLoading: false,
                printDriverPackageSuccess: true,
                printDriverPackageAlertType:RESPONSE_TYPE.SUCCESS,
                printDriverPackageAlertMessage: PRINT_DRIVER_PACKAGE_SUMMARY_SUCCESS_MESSAGE};
        case PRINT_DRIVER_PACKAGE_SUMMARY_ERROR:
            return {...state,
                printDriverPackageSummaryData: [],
                printDriverPackageSuccess: false,
                printDriverPackageAlertType:RESPONSE_TYPE.ERROR,
                printDriverPackageAlertMessage: PRINT_DRIVER_PACKAGE_SUMMARY_ERROR_MESSAGE};
        case TOGGLE_PRINT_DRIVER_PACKAGE_SUMMARY_BUTTON:
            return { ...state, enablePrintDriverPackageSummaryButton: !state.enablePrintDriverPackageSummaryButton}
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/reducer/PrintDriverPackageSummaryReducer.js